const TeamCard = ({ name, position, image, description }) => {
  return (
    <div className="bg-[#F6F6F6] group p-4 rounded-[17px] flex flex-col gap-3">
      <div className="lg:min-h-[432px] rounded-xl  min-h-[360px] w-full   relative overflow-hidden">
        <img
          className="rounded-xl h-full w-full group-hover:scale-105 absolute inset-0 transition-all duration-300 object-cover"
          src={image}
          height={432}
          width={432}
          alt={`${name}'s image`}
        />
      </div>
      <div className="p-5 bg-white space-y-3 rounded-xl h-full">
        <div>
          <p className="text-[#433CAE] text-[32px] leading-10 font-semibold ">
            {name}
          </p>
          <p className="text-[#B0B0B0] font-medium ">{position}</p>
        </div>
        <p className="text-[#1C1C1C] font-medium ">{description}</p>
      </div>
    </div>
  );
};

export default TeamCard;
